import { render, staticRenderFns } from "./queryNews.vue?vue&type=template&id=28bb1ac5&scoped=true&"
import script from "./queryNews.vue?vue&type=script&lang=js&"
export * from "./queryNews.vue?vue&type=script&lang=js&"
import style0 from "./queryNews.vue?vue&type=style&index=0&id=28bb1ac5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bb1ac5",
  null
  
)

export default component.exports